export default "__VITE_ASSET__BwnLWQ_R__ 100w";